var Marionette = require('backbone.marionette');

var RelationsTypesSelectView = require('./relations-types-select');
var EntitiesSelectView = require('../entities/entities-select');
var RelationModel = require('../../models/relation-model');

var RelationsFormView = Marionette.View.extend({
    template: require('../../templates/relations/relations-form.html'),
    regions:{
        types: "#types-container",
        entities: "#entities-container"
    },

    childViewEvents:{
        'type:selected': 'typeSelected',
        'entity:selected': 'entitySelected'
    },

    events:{
        'click #save-relation': 'saveRelation'
    },

    initialize: function(options){
        this.model = new RelationModel();
        _.bindAll(this, 'onRender', 'typeSelected', 'entitySelected', 'saveRelation',
            'afterUpdate', 'afterFetchedUpdated');
        if (options){
            this.reversed = options.reversed;
            this.parentId = options.parentId;
            this.model.set('parentId', options.parentId);
            if (options.type){
                this.model.set('type', {
                    id: options.type
                });
            }
            if (options.entity){
                this.entityId = options.entity;
                this.model.set('child', {
                    id: options.entity
                });
            }
            this.relationTypes = options.relationTypes || [];
            this.childrenTypes = options.childrenTypes || [];
            this.parentTypes = options.parentTypes || [];
        }

        this.model.view = this;
        this.model.bind("validated", this.validated);
    },

    validated: function(valid) {
        var saveBtn = this.view.$('#save-relation');
        if (valid){
            saveBtn.removeAttr("disabled");
        } else {
            saveBtn.attr("disabled", "true");
        }
    },

    onRender: function(){
        this.relationTypeSelectView = new RelationsTypesSelectView({
            type: this.type,
            relationTypes: this.relationTypes,
            childrenTypes: this.childrenTypes,
            parentTypes: this.parentTypes,
            reversed: this.reversed
        });
        this.showChildView('types', this.relationTypeSelectView);
    },

    typeSelected: function (data) {
        this.model.set('type', {
            id: data.relationType
        });
        this.entitiesSelectView = new EntitiesSelectView({entityType: data.entityType});
        this.showChildView('entities', this.entitiesSelectView);
    },

    entitySelected: function (data) {
        if (this.reversed){
            this.parentId = data.id;
            this.model.set('parentId', data.id);
            this.selectedName = data.name;
        } else{
            this.model.set('child', {
                id: data.id
            });
        }
    },

    saveRelation: function(){
        this.model.save(this.model.toJSON(), {success: this.afterUpdate});
    },

    afterUpdate: function (){
        this.model.fetch({success: this.afterFetchedUpdated});
    },

    afterFetchedUpdated: function (){
        if (this.reversed){
            var reversedModel = this.model.clone();
            reversedModel.set('parentId', this.model.get('child').id);
            reversedModel.set('child', {id: this.model.get('parentId'), name: this.selectedName});
            this.triggerMethod('relation:saved', reversedModel);
        } else{
            this.triggerMethod('relation:saved', this.model.clone());
        }
        this.model.clear().set(this.model.defaults);
        /*this.model.set('parentId', this.parentId);
        this.model.set('child', {
            id: this.entityId
        });*/
    }

});

module.exports = RelationsFormView;


//////////////////
// WEBPACK FOOTER
// ./app/views/relations/relations-form.js
// module id = 221
// module chunks = 0